<template>
  <ThreeColumn :breadcrumbPaths="paths">
    <template v-slot:title>
      <h1 class="text-h1 mb-0">{{$t('feedback.page_title')}}</h1>
    </template>

    <template v-slot:mainPanel>
      <v-alert
        type="success"
        text 
        class="mr-6 mb-10"
        icon="mdi-check-circle-outline"
      >
        {{$t('feedback.success')}}
      </v-alert>
                    
      <v-card flat class="my-10">
        <v-card-actions class="pr-7" v-if="!$vuetify.breakpoint.xs">
          <v-spacer></v-spacer>
          <v-btn large text class="px-4 mr-4 navlink--text" @click="$router.push('/feedback')">
            {{$t('btntxt.back')}}{{$t('feedback.page_title')}}
          </v-btn>
          <v-btn large tile elevation="0" color="navlink" class="white--text px-4 ml-0"  @click="$router.push('/')">
            {{$t('btntxt.ft_home')}}
          </v-btn>
        </v-card-actions>

        <v-col v-else class="pl-0 pt-10">
          <v-btn block text class="lightgrey navlink--text mb-4"  @click="$router.push('/feedback')">
            {{$t('btntxt.back')}}{{$t('feedback.page_title')}}
          </v-btn>
          <v-btn block tile elevation="0" color="navlink" class="white--text px-4"  @click="$router.push('/')">
            {{$t('btntxt.ft_home')}}
          </v-btn>
        </v-col>
      </v-card>
                
      <v-card flat class="my-16 py-16"></v-card>
    </template>
  </ThreeColumn>
</template>
<script>
  import ThreeColumn from '@/components/applayout/ThreeColumn'
  export default {
    name: 'FeedbackSuccess',
    components: {
      ThreeColumn
    },
    data(){return {
    }},
    methods:{
    },
    computed:{
      paths(){
        return[
          {text: 'HKLII', disabled: false, href: {name: 'home'}},
          {text: this.$i18n.t('btntxt.feedback'), disabled: true}
        ]
      }
    },
    /*mounted(){
      window.document.title = 'Feedback | HKLII'
    }*/
    metaInfo(){
      return{
        title: this.$i18n.t('feedback.page_title'),
      }
    },
  }
</script>